exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title{position:absolute;top:-65px;background:#000;border-radius:4px;color:#fff;padding:.35rem .5rem;width:175px;left:calc(50% - 87.5px);font-size:small}.title:after{content:\"\";position:absolute;bottom:-20px;left:calc(50% - 10px);border:10px solid transparent;border-top-color:#000}", ""]);

// exports
